import { YushengAxiosInstance } from 'common/service/axiosInstances';
import { AIModel, YushengVoice } from 'common/types';

export interface AiModelParams extends AIModel {
  pageIndex?: number;
  pageSize?: number;
}

const yusheng = {
  updateVoiceVisible: (
    params: Pick<YushengVoice, 'speakerId'> & { projectCode: string },
  ): ExtendAxioResponse<AIModel[]> => {
    return YushengAxiosInstance.post(`/speaker/update/visible`, params);
  },
  getAllVoiceList: (params: AiModelParams): ExtendAxioResponse<YushengVoice[]> => {
    return YushengAxiosInstance.post(`/speaker/public`, params);
  },
};

export default yusheng;
